import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import One from "../images/one.svg"
import Two from "../images/two.svg"

import { Link, graphql } from "gatsby"

import rightArrow from "../images/right-arrow.svg"

import icon1 from "../images/coaching/icon1.svg"
import icon2 from "../images/coaching/icon2.svg"
import icon3 from "../images/coaching/icon3.svg"
import icon4 from "../images/coaching/icon4.svg"
import icon5 from "../images/coaching/icon5.svg"
import icon6 from "../images/coaching/icon6.svg"
import icon7 from "../images/coaching/icon7.svg"
import icon8 from "../images/coaching/icon8.svg"

import wheelOfLife from "../images/wheel-of-life.jpg"

import Modal from "../components/modals/getstarted"
import Modal2 from "../components/modals/schedule"

const ExecutiveLeadershipCoaching = () => (
  <Layout>
    <SEO
      title="Executive And Leadership Coaching"
      description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    />
    <div className="container-fluid page-head about-us text-center">
      <div className="container p-relative page-heading">
        <div>
          <h1 className="inner-page-h1 font-weight-bold">
            Leadership Development & Executive Coaching
          </h1>
          <h2 className="mt-0">Navigate Better and Scale!</h2>
        </div>
      </div>
      <div className="row heading-blocks"></div>
    </div>
    <div className="container-fluid page-body">
      <div className="custom-container">
        <div className="section-one">
          <div className="row">
            <div className="col-lg-10 mx-auto text-center"></div>
          </div>
          <div className="col-12 text-center pb-5">
            <h2 className="mx-auto mb-5">
              The Leadership Manifesto: Evolve your leadership mindset.
            </h2>{" "}
            <h3 className="mt-0 mb-5">
              As empathy, communication and emotional intelligence become more
              important, more CEOs are seeking professional coaches to help
              develop these skills and enrich mindfulness.
            </h3>
            <p className="text-justify">
              While the game might look the same, the rules have changed. Yes,
              the basics are still there (EBITDA, Sales, Growth, Retention,
              Legal, Marketing), however, there are new players in the game.
              There have been seismic shifts in business modes over the past
              year(s): AI, the Cloud, 5G have all changed the landscape, but
              what has really evolved is the need for a different kind of
              leadership, a more contemplative, engaging and moral one. Whether
              it's re-evaluating the C-Suite to meet ever-changing market and
              internal demands or a complete restructuring, the need is clear -
              changing or adding C-Suite insight, capabilities and sensitivities
              is more critical now than ever.{" "}
            </p>
            <h3 className="mb-5">People are hungry for normal.</h3>
            <p className="text-justify">
              82% of US CEOs have added a new C-Level position in the last five
              years. Including the roles of Chief of Innovation, Digital,
              Strategy, Growth, Ethics, People, and Data. Many of the people
              being considered for these operational additions are being
              considered only if they have an "empathy gene." Yes, they have to
              care about the people they work with as well as today's social
              imperatives and issues (i.e environment, education, health
              disparities, water, poverty) and with Diversity, Equality and
              Inclusion rising to the top of the list,{" "}
              <strong>
                mindfulness and leadership development have become even more
                critical.
              </strong>{" "}
              Empathy, humility, communication skills, community building and
              mindfulness are being heralded as equally, if not more important,
              than their abilities and previous accomplishments.{" "}
              <strong>
                The ability to step back and think about where you want to take
                the organization is more imperative today than ever.
              </strong>
            </p>
            <p className="text-justify">
              Many companies are recognizing that their long-term interests are
              best accomplished with a{" "}
              <strong>whole-person or holistic approach</strong> that includes
              the interests of employees, customers, suppliers, investors and
              the communities in which you do business. This is in addition to
              leadership being aligned and appropriate for where the
              organization is in it's Stage of Development.
            </p>
            <p className="text-justify">
              The role of the corporation is being redefined, and therefore, so
              must its leadership and mindset. In a statement released by the
              Business Roundtable, redefining the US Corporation's role to
              include promoting "an economy that serves all Americans" is as or
              more important to the company's long-term success as the financial
              bottom line.
            </p>
            <p className="text-justify">
              By quickly understanding where you and your company are,
              Management Insight guides leadership to get back on or moving down
              the path towards success - FAST.
            </p>
            <Modal />
          </div>

          <div className="col-lg-12">
            <h2 className="text-center">
              Holistic Leadership-Centered Personal Coaching
            </h2>

            <div className="row pt-5 text-center">
              {" "}
              <div className="col-lg-3 pt-5 coaching-container">
                <img
                  style={{ width: "100px" }}
                  src={icon1}
                  alt="Improve Relationships with Family and Friends"
                />
                <h5 className="mt-3 mb-5">
                  Improve Relationships: Business, Family and Friends
                </h5>
              </div>
              <div className="col-lg-3 pt-5 coaching-container">
                <img
                  style={{ width: "100px" }}
                  src={icon2}
                  alt="Improve Relationships with Family and Friends"
                />
                <h5 className="mt-3 mb-5">
                  Understand and Become a Better Leader
                </h5>
              </div>
              <div className="col-lg-3 pt-5 coaching-container">
                <img
                  style={{ width: "100px" }}
                  src={icon3}
                  alt="Improve Relationships with Family and Friends"
                />
                <h5 className="mt-3 mb-5">
                  Improve your Romantic Relationships{" "}
                </h5>
              </div>
              <div className="col-lg-3 pt-5 coaching-container">
                <img
                  style={{ width: "100px" }}
                  src={icon4}
                  alt="Improve Relationships with Family and Friends"
                />
                <h5 className="mt-3 mb-5">Find your Purpose</h5>
              </div>
              <div className="col-lg-3 pt-5 coaching-container">
                <img
                  style={{ width: "100px" }}
                  src={icon5}
                  alt="Improve Relationships with Family and Friends"
                />
                <h5 className="mt-3 mb-5">Improve your Attitude and Health</h5>
              </div>
              <div className="col-lg-3 pt-5 coaching-container">
                <img
                  style={{ width: "100px" }}
                  src={icon6}
                  alt="Improve Relationships with Family and Friends"
                />
                <h5 className="mt-3 mb-5">Gain Clarity in your Life</h5>
              </div>
              <div className="col-lg-3 pt-5 coaching-container">
                <img
                  style={{ width: "100px" }}
                  src={icon7}
                  alt="Improve Relationships with Family and Friends"
                />
                <h5 className="mt-3 mb-5">Get Ahead of your Finances</h5>
              </div>
              <div className="col-lg-3 pt-5 coaching-container">
                <img
                  style={{ width: "100px" }}
                  src={icon8}
                  alt="Improve Relationships with Family and Friends"
                />
                <h5 className="mt-3 mb-5">
                  Gain Traction in your Business or Career
                </h5>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-lg-6">
              <p>
                <strong>
                  Helping you to discover and clarify a game worth playing.
                </strong>{" "}
                We serve leadership and founders of growing and accelerating
                companies who are looking to go deeper into what’s important and
                what drives them forward. While I have worked with billion
                dollar companies, I have worked with numerous start-ups and
                organizations with between $3 and $25 million in revenue.
              </p>
              <p>
                <strong>Personal Coaching</strong> – depending on the situation
                many areas can be explored and improved, including:
              </p>
              <div className="row">
                <div className="col-lg-5">
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Fun and Recreation
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Family and Friends
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Personal Growth
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Relationships
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Purpose
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Attitude
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Clarity
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Health
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Finances
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Romance
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Business/Career
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Physical Environment
                  </p>
                  <p className="mb-0">
                    <img
                      src={rightArrow}
                      style={{ width: "20px", marginRight: "10px" }}
                    />
                    Direction and Distractions
                  </p>
                </div>
                <div className="col-lg-7 d-flex justify-content-center align-items-center">
                  <img
                    className="img-fluid"
                    src={wheelOfLife}
                    alt="Wheel of Life"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <h3 className="mt-0">Wheel of Life</h3>
              <p>
                The Wheel of Life is an extraordinary yet simple tool used to
                determine which areas in your life are working best and those
                which need attention or improvement. We then help leverage and
                accentuate these positive areas. Once we have a clear idea of
                where you are, we then discuss where you want to be (GAP), then
                we create an improvement plan to get all areas in alignment and
                move you forward.
              </p>
              <p>
                Additionally, if you are going through a particularly tough or
                interesting time (aren't we all?) in your life, it's another way
                of helping you quickly get visibility of what specific areas you
                may be dismissing or spending less time working on. On the
                flip-side, if you are finding you are going through a period of
                extreme happiness, joy and fulfillment, we also recommend
                completing a Wheel of Life at this point in time as it will
                indicate where you are spending your time and what it is that is
                making you truly happy. By understanding this, it will help in
                determining what you truly want to do at this phase in your
                life, and ultimately, be your guide for experiencing ongoing
                happiness.
              </p>
              <p>
                Through these and other targeted efforts Management Insight gets
                to the true roots of the issues that may or may not be affecting
                your life, and guides you in crafting a plan for improving those
                which need attention.
              </p>
              <div className="d-flex justify-content-around">
                {" "}
                <Modal />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default ExecutiveLeadershipCoaching
